import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Cartes Bancaires",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M34.0645 5.09155H14.6078C14.0912 5.09155 13.6724 5.51035 13.6724 6.02697V18.7487C13.6724 19.2653 14.0912 19.6841 14.6078 19.6841H34.0645C34.5811 19.6841 35 19.2653 35 18.7487V6.02697C35 5.51035 34.5811 5.09155 34.0645 5.09155Z",
				fill: "url(#paint0_linear_13_5710_cb_dark)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.652 12.166H24.5904C24.5642 11.5309 24.4162 10.8761 23.9674 10.4555C23.4327 9.9544 22.4962 9.76855 21.6594 9.76855C20.7885 9.76855 19.8253 9.9724 19.2878 10.51C18.8243 10.9731 18.7241 11.7182 18.7241 12.3876C18.7241 13.0888 18.9201 13.9045 19.423 14.3743C19.9576 14.8742 20.824 15.0069 21.6594 15.0069C22.4711 15.0069 23.3503 14.8571 23.8818 14.3825C24.4119 13.9084 24.595 13.1099 24.595 12.3876V12.3842H21.652V12.166ZM24.7876 12.3843V14.8898H28.8752V14.8864C29.4733 14.8538 29.9492 14.3145 29.9492 13.6524C29.9492 12.99 29.4733 12.4161 28.8752 12.3832V12.3843H24.7876ZM28.8287 9.87347C29.4116 9.87347 29.8743 10.3793 29.8743 11.0175C29.8743 11.6217 29.4494 12.1152 28.9088 12.1661H24.7876V9.8698H28.6997C28.7238 9.86685 28.7518 9.86894 28.7793 9.87096C28.7964 9.8722 28.8132 9.87347 28.8287 9.87347Z",
				fill: "#FEFEFE"
			})]
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_13_5710_cb_dark",
		x1: 19.3717,
		y1: 3.00919,
		x2: 14.0977,
		y2: 19.1993,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#222E72" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .591647,
				stopColor: "#40CBFF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#3CB792"
			})
		]
	}) })]
});
export default SvgCb;
